import { createFromIconfontCN } from '@ant-design/icons';
import React, { CSSProperties } from 'react';

const IconFont = createFromIconfontCN({
  scriptUrl: require('./iconfont'),
});

type Props = {
  type: 'backspace' | 'keyboard' | 'keyboard-collapse' | 'cashPay';
  className?: string;
  style?: CSSProperties;
};

const CustomIcon: React.FC<Props> = ({ type, className = '', style }) => {
  return <IconFont className={className} type={`icon-${type}`} style={style} />;
};

export default CustomIcon;
